import { Link } from "react-router-dom/cjs/react-router-dom.min"

export const SUCCESS_MESSAGES = {
    "export": {
        message: <div style={{color: 'white'}}>Your export is in progress and will be ready shortly. Once ready, you can download it from the <Link className="text_link" to="/data-exports">Data Exports</Link> page, and we’ll also email you.</div> 
    },
    "add_prospect": {
        message: (redirect_url) => (
            <div>
                Prospect added, head to the prospect’s{' '}
                <Link className="text_link hover_under_line" to={redirect_url}>
                Profile Page
                </Link>{' '}
                to enter additional details.
            </div>
        )
    }
}

export const WARNING_MESSAGES = {
    "export": {
        message: <div>You currently have 5 export requests in progress. Please wait for one to complete before starting a new export. You can check their status on the <Link className="text_link" to="/data-exports">Data Exports</Link> page.</div>
    }
}